import React from "react";

function ServiceSection() {
  return (
    <section className="services-section pt-120 rpt-100 pb-90 rpb-70">
      <div className="container">
        <div className="row">
          <div className="col-xl-3 col-sm-6">
            <div className="service-box wow fadeInUp delay-0-2s">
              <div className="service-normal">
                <div className="icon">
                  <i className="flaticon flaticon-computer"></i>
                </div>
                <h6>Consultancy</h6>
                <p>
                  We analyze and advise on IT strategy deployment, Work and process flow optimizations.
                </p>
                <a className="btn-circle" href="/services/consultancy">
                  <i className="fas fa-long-arrow-alt-right"></i>
                </a>
              </div>
              <div className="service-hover bg-blue text-white">
                <h3>Consultancy</h3>
                <p>We analyze and advise on IT strategy deployment, Work and process flow optimizations.</p>
                <a href="/services/consultancy" className="theme-btn">
                  Learn More
                </a>
              </div>
            </div>
          </div>
          <div className="col-xl-3 col-sm-6">
            <div className="service-box wow fadeInUp delay-0-4s">
              <div className="service-normal">
                <div className="icon">
                  <i className="flaticon flaticon-web-development-4"></i>
                </div>
                <h6>integrations</h6>
                <p>
                  Integrating existing tools and systems is a large part of our work. To create scalable service architectures.
                </p>
                <a className="btn-circle" href="/services/integrations">
                  <i className="fas fa-long-arrow-alt-right"></i>
                </a>
              </div>
              <div className="service-hover bg-blue text-white">
                <h3>integrations</h3>
                <p>Integrating existing tools and systems is a large part of our work. To create scalable service architectures.</p>
                <a href="/services/integrations" className="theme-btn">
                  Learn More
                </a>
              </div>
            </div>
          </div>
          <div className="col-xl-3 col-sm-6">
            <div className="service-box wow fadeInUp delay-0-6s">
              <div className="service-normal">
                <div className="icon">
                  <i className="flaticon flaticon-web"></i>
                </div>
                <h6>Development</h6>
                <p>
                  When necessary we develop custom software, components, user interfaces and dashboards.
                </p>
                <a className="btn-circle" href="/services/development">
                  <i className="fas fa-long-arrow-alt-right"></i>
                </a>
              </div>
              <div className="service-hover bg-blue text-white">
                <h3>Development</h3>
                <p>When necessary we develop custom software, components, user interfaces and dashboards.</p>
                <a href="/services/development" className="theme-btn">
                  Learn More
                </a>
              </div>
            </div>
          </div>
          <div className="col-xl-3 col-sm-6">
            <div className="service-box wow fadeInUp delay-0-8s">
              <div className="service-normal">
                <div className="icon">
                  <i className="flaticon flaticon-data"></i>
                </div>
                <h6>Automation</h6>
                <p>
                  Wherever we can, we will automate work and order flows. Get rid of manual processes.
                </p>
                <a className="btn-circle" href="/services/automation">
                  <i className="fas fa-long-arrow-alt-right"></i>
                </a>
              </div>
              <div className="service-hover bg-blue text-white">
                <h3>Automation</h3>
                <p>Wherever we can, we will automate work and order flows. Get rid of manual processes.</p>
                <a href="/services/automation" className="theme-btn">
                  Learn More
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ServiceSection;
